import { Typography } from "@/components/ui/typography";
import { cn } from "@/components/ui/utils";

/**
 * Unified group container that adapts its presentation based on layout mode.
 * - "tabs" mode: no card styling, show/hide based on visibility
 * - "cards" mode: render as a styled card with optional title
 */
export function NodeGroupContainer({
  children,
  title,
  isVisible,
  layoutMode,
  card,
  isLabelVisible = true,
}: {
  children: React.ReactNode;
  title?: string;
  isVisible: boolean;
  layoutMode: "tabs" | "cards";
  /** Its share of the row, and whether its body runs to its edges. */
  card?: { flex?: number; isFlush?: boolean };
  isLabelVisible?: boolean;
}) {
  if (layoutMode === "tabs") {
    return (
      <div className={cn(isVisible ? "flex" : "hidden", "flex-col")}>
        {children}
      </div>
    );
  }

  return (
    <div
      className={cn(
        "relative rounded-md flex flex-col [border-width:1px] [border-style:solid] border-border shadow-sm p-4 bg-[color-mix(in_srgb,var(--muted)_70%,transparent)]",
        card?.flex === 1 && "flex-1",
        card?.isFlush && "p-0",
        "w-full max-w-full min-w-0 min-h-full overflow-hidden",
      )}
    >
      {title && isLabelVisible && (
        <Typography level="title-md" className="mb-3 text-muted-foreground">
          {title}
        </Typography>
      )}
      {children}
    </div>
  );
}
